import { request, requestBlob } from '../request'
import { createCachedRequest } from '@/utils/helpers'

/** 获取枚举数据 */
export function listEnumData(data = {}) {
  return request('data/listEnumData', data)
}

/** 模板列表（带缓存）
 * 模板数据较大（~900KB），适合缓存
 */
const templateCache = createCachedRequest(
  (data) => request('data/listTemplate', data),
  'template_cache',
  () => 'default',
)
export const listTemplate = templateCache.cachedFn
export const clearTemplateCache = templateCache.clearCache

/** 模板列表（不缓存，用于模板管理页面搜索） */
export function listTemplateRaw(data) {
  return request('data/listTemplate', data)
}

/** 打印记录 */
export function listPrintLog(data) {
  return request('data/listPrintLog', data)
}

/** 新增/更新通知 */
export function upsertNotice(data) {
  return request('account/upsertNotice', data)
}

/** 通知列表 */
export function listNotice(data) {
  return request('account/listNotice', data)
}

/** 删除通知 */
export function delNotice(data) {
  return request('account/delNotice', data)
}

/** 批量删除通知 */
export function batchDelNotice(data) {
  return request('account/batchDelNotice', data)
}

/** 通知详情 */
export function getNoticeDetail(data) {
  return request('account/getNoticeDetail', data)
}

/** 获取打印详情 */
export function getPrintDetail(data) {
  return request('data/getPrintDetail', data)
}

/** 新增法律文书模板记录 */
export function addLawTemplate(data) {
  return request('data/addLawTemplate', data)
}

/** 新增打印记录 */
export function addPrintLog(data) {
  return request('data/addPrintLog', data)
}

/** 新增/更新模板 */
export function upsertTemplate(data) {
  return request('data/upsertTemplate', data)
}

/** 删除模板 */
export function delTemplate(data) {
  return request('data/delTemplate', data)
}

/** 恢复已删除的模板 */
export function restoreTemplate(data) {
  return request('data/restoreTemplate', data)
}

/** 更新日志列表 */
export function listUpdateLog(data) {
  return request('data/listUpdateLog', data)
}

/** 更新日志详情 */
export function getUpdateLog(data) {
  return request('data/getUpdateLog', data)
}

/** 保存/更新更新日志 */
export function saveUpdateLog(data) {
  return request('data/saveUpdateLog', data)
}

/** 删除更新日志 */
export function delUpdateLog(data) {
  return request('data/delUpdateLog', data)
}

/** 执行数据库备份 */
export function backupDatabase(data = {}) {
  return request('data/backupDatabase', data)
}

/** 获取备份文件列表 */
export function listBackupFiles(data = {}) {
  return request('data/listBackupFiles', data)
}

/** 服务器资源使用率（CPU/内存/磁盘） */
export function serverStats(data = {}) {
  return request('data/serverStats', data)
}

/** 删除备份文件 */
export function delBackupFile(data = {}) {
  return request('data/delBackupFile', data)
}

/** 压缩备份文件（异步任务，生成 .sql.gz） */
export function compressBackupFile(data = {}) {
  return request('data/compressBackupFile', data)
}

/** 下载备份文件（blob 流） */
export function downloadBackupFile(data = {}) {
  return request('data/downloadBackupFile', data)
}

/** 获取操作日志文件列表 */
export function listLogFiles(data = {}) {
  return request('data/listLogFiles', data)
}

/** 读取指定日志文件最新N行 */
export function readLogFile(data) {
  return request('data/readLogFile', data)
}

/** 删除指定日志文件 */
export function deleteLogFile(data) {
  return request('data/deleteLogFile', data)
}

/** 分析所有日志文件，返回每日操作统计 */
export function analyzeLogFiles(data = {}) {
  return request('data/analyzeLogFiles', data)
}

// ============================================================
// 文书展示规则 API
// ============================================================

/** 查询文书展示规则列表 */
export function listDocDisplayRules(data) {
  return request('data/listDocDisplayRules', data)
}

/** 新增/更新文书展示规则 */
export function upsertDocDisplayRule(data) {
  return request('data/upsertDocDisplayRule', data)
}

/** 删除文书展示规则 */
export function delDocDisplayRule(data) {
  return request('data/delDocDisplayRule', data)
}

/** 根据案件类型+阶段+特征查询可用模板ID列表 */
export function getDocDisplayTemplates(data) {
  return request('data/getDocDisplayTemplates', data)
}

// ============================================================
// 接口访问统计 API
// ============================================================

/** 获取可用的API日志日期列表 */
export function listApiLogDates(data) {
  return request('data/listApiLogDates', data)
}

/** 获取指定日期的接口访问统计 */
export function getApiStats(data) {
  return request('data/getApiStats', data)
}
